import React, { Component } from "react";
import { FormProps, FormState, IPForm } from "./index";
import { RVEnvironment, SearchOption } from "../../../api/entities";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { ErrorContainer } from "@eres/forms";
import TextInputField from "@my-dld/components/Form/TextInputField";
import Strings from "@my-dld/assets/strings";

interface State extends FormState {
	number?: string;
}

export class DewaForm extends Component<FormProps, State> implements IPForm {
	constructor( props: FormProps ) {
		super( props );
		this.state = {
			errorContainer: {},
		};
	}

	render() {
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		const { errorContainer } = this.state;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-md-4">
						<TextInputField
							{ ...kvProp }
							id={ "number" }
							required={ true }
							label={ Strings.dewa_premise }
							containerClassName="form-group"
							error={ errorContainer.number }
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}

	updateParams( opts: SearchOption, env: RVEnvironment ): void {
		opts.dewaPremise = this.state.number;
	}

	validate( opts: SearchOption, env: RVEnvironment ): boolean {
		let isValid: boolean = true;
		let errorContainer: ErrorContainer = {};
		isValid = checkNonEmpty( this.state, "number", errorContainer ) && isValid;
		this.setState( {
			errorContainer: errorContainer,
		} );
		return isValid;
	}
}
